import React from 'react'
import { useMutation } from 'react-apollo'
import { Helmet } from 'react-helmet'
import useServerError from '../../../src/hooks/useServerError'
import { Form, FormIdentifier } from '../forms/FieldFactory'
import FormBuilder from '../../components/forms/FormBuilder'
import ResetPasswordMutation from '../../graphql/ResetPasswordMutation.gql'
import {
  BasicType,
  ElementType,
} from '../../../src/components/forms/FormElementParts'
import { FormData } from '../../../src/components/forms/FormCollector'
import { getQueryParamValue } from '../../../src/lib/uri'

// TODO: will need to add handling for these links to to through the router
// once sign in and invitation are converted over
const form: Form = {
  fields: [
    {
      icon: 'Key',
      label: 'New Password',
      name: 'password',
      type: ElementType.PASSWORD,
    },
    {
      description: `
        Password must be longer than 8 characters, include a number, at least one
        upper and lower case letter and a special character (~’!@#$%^&*()-_+={}[]|\\;:<>,./?)
      `,
      icon: 'Key',
      label: 'New Password Confirmation',
      name: 'passwordConfirmation',
      type: ElementType.PASSWORD,
    },
    {
      label: 'Change My Password',
      type: BasicType.SUBMIT,
    },
    {
      label: "Already have an account? <a href='/sign_in'>Sign In</a>",
      type: BasicType.FOOTER,
    },
    {
      label: "<a href='/invitation/resend'>Lost Invitation?</a>",
      type: BasicType.FOOTER,
    },
  ],
  header: 'Change Your Password',
  type: FormIdentifier.CHANGE_PASSWORD,
}

export default () => {
  const [resetPassword, { data, error }] = useMutation(ResetPasswordMutation)
  const { clearServerError, serverError, setServerError } = useServerError()
  const handleSubmitForm = React.useCallback(
    (formData: FormData) => {
      const resetPasswordToken = getQueryParamValue('reset_password_token')
      resetPassword({
        variables: {
          ...formData,
          resetPasswordToken,
        },
      })
    },
    [resetPassword],
  )
  React.useEffect(() => {
    if (error && error.graphQLErrors.length) {
      const err: any = error.graphQLErrors[0]
      setServerError({ message: err.message, errors: err.fields })
    } else {
      clearServerError()
    }
  }, [clearServerError, error, setServerError])
  if (data && data.resetPassword) {
    window.location.href = '/'
  }

  return (
    <React.Fragment>
      <Helmet
        title={`${
          (window as any).CMD.config.tenant.page_title
        } - Change Password`}
      />
      <FormBuilder
        form={form}
        key={form.type}
        onChange={clearServerError}
        onSubmit={handleSubmitForm}
        serverError={serverError}
      />
    </React.Fragment>
  )
}
